// extracted by mini-css-extract-plugin
module.exports = {"line":"remit_line__1s-JU","mobileAppWrapper":"remit_mobileAppWrapper__C0GKI"};